export default __webpack_public_path__ + "static/media/arrow-up.95e389ca.svg";